import styled from "styled-components";
import { breakpoints } from "@tvg/design-system";

export const Container = styled.div<{ numberOfTabs: number }>`
  padding: ${({ theme }) => theme.space["space-4"]};
  display: flex;

  @media screen and ${breakpoints.tablet.max.sm} {
    justify-content: space-between;
    row-gap: ${({ theme }) => theme.space["space-4"]};
    flex-direction: ${({ numberOfTabs }) =>
      numberOfTabs > 1 ? "column" : "row"};
  }
`;

export const FiltersContainer = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  padding: 8px;

  @media screen and ${breakpoints.tablet.max.sm} {
    flex-direction: column;
    margin-top: ${({ theme }) => theme.space["space-4"]};
    padding: 0;
  }
`;

export const BadgeContainer = styled.div`
  display: inline-flex;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;

  @media screen and ${breakpoints.tablet.max.sm} {
    right: -8px;
    top: -8px;
  }
`;

export const ContainerParagraph = styled.div`
  @media screen and ${breakpoints.tablet.max.sm} {
    display: flex;
    align-items: center;
  }
`;
